import classNames from 'classnames';
import React, { ReactNode } from 'react';
import styles from './Toggle.module.css';

function Toggle({
  id,
  active,
  setactive,
  label,
  leftLabel,
}: {
  id: string,
  active: boolean,
  setactive: (newactive: boolean) => void,
  label?: ReactNode,
  leftLabel?: ReactNode
}) {
  return (
    <div
      className={classNames('field', styles.toggleContainer)}
    >
      <div className={styles.toggle}>
        {leftLabel}
      </div>
      <input
        id={id}
        type="checkbox"
        name={id}
        className="switch is-rounded is-primary"
        checked={active}
        onChange={() => setactive(!active)}
      />
      <label htmlFor={id} className={classNames(styles.toggle)}>
        {label}
      </label>
    </div>
  );
}

Toggle.defaultProps = {
  label: undefined,
  leftLabel: undefined,
};

export default Toggle;
